import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalRuleEntry  {
    _originalTypeClassName = "zERP.BO.GeneralJournalRuleEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalRuleEntry.translate = translateService;
}
this.Journal = new Domain.AccountingJournal();
this.GeneralJournalRuleDetails = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Ledger:any;
Journal:any;
GeneralJournalRuleDetails:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setJournal = ($this, value) => {
var oldValue = $this.Journal;
$this.Journal = value;
if (value != null) {
}
}
static setGeneralJournalRuleDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.GeneralJournalRuleDetails == null) $this.GeneralJournalRuleDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GeneralJournalRuleDetails.length > 0) {
                    Domain.GeneralJournalRuleEntry.removeGeneralJournalRuleDetails($this, $this.GeneralJournalRuleDetails[0]);
                }

                Domain.GeneralJournalRuleEntry.addManyGeneralJournalRuleDetails($this, copyItems);
            }
static addManyGeneralJournalRuleDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalRuleEntry.addGeneralJournalRuleDetails($this, items[i]);
                }
            }
static addGeneralJournalRuleDetails = ($this, item) => {
                if ($this.GeneralJournalRuleDetails == null) $this.GeneralJournalRuleDetails = [];
                if (item == null || $this.GeneralJournalRuleDetails.indexOf(item) > -1) return;
                $this.GeneralJournalRuleDetails.push(item);
}
static addRangeGeneralJournalRuleDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalRuleEntry.addGeneralJournalRuleDetails($this, item));
            }
static removeGeneralJournalRuleDetails = ($this, item) => {
                if ($this == null || $this.GeneralJournalRuleDetails == null || $this.GeneralJournalRuleDetails.indexOf(item) === -1) return;
                var _index = $this.GeneralJournalRuleDetails.indexOf(item);
                $this.GeneralJournalRuleDetails.splice(_index, 1);
}
static clearGeneralJournalRuleDetails = ($this) => { $this.GeneralJournalRuleDetails = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}